export enum EntityTab {
  Result = 'result',
  ProvidedInfo = 'providedInfo',
}
